import WidgetContext from 'embed_v2/components/Context'
import useDebounce from 'embed_v2/hooks/useDebounce'
import { useState, useCallback, useContext } from 'preact/hooks'
import { getStylesFn } from 'core/helpers/styles'
import type { ElementTextareaOptions } from 'core/types/element/element_textarea'
import optionsPropTypes from 'PropsSpec'
import CommonTextarea from './common/Textarea'

const extractStyles = getStylesFn(['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'], {
  width: '100%',
  height: '100%'
})

type Props = {
  options: ElementTextareaOptions
}

const Textarea = (props: Props) => {
  const { setViewerField, notification } = useContext(WidgetContext)
  const { options } = props
  const [value, setValue] = useState('')
  const errors = notification.errors[options.key]

  const debouncedChangeHandler = useDebounce(setViewerField)

  const onChange = useCallback((val: string) => {
    setValue(val)
    debouncedChangeHandler(options.key, val)
  }, [])

  const styles = extractStyles(options)

  return (
    <div style={styles} className="wf_reset wf_field wf_field_textarea">
      <CommonTextarea
        value={value}
        name={options.key}
        onChange={onChange}
        options={options.input}
        placeholder={options.label}
        rows={options.rows}
        errorText={errors}
      />
    </div>
  )
}

Textarea.propTypes = {
  options: optionsPropTypes('textarea')
}

export default Textarea
